import { render } from "./CreditManagement.vue?vue&type=template&id=06ab1b42&scoped=true"
import script from "./CreditManagement.vue?vue&type=script&lang=js"
export * from "./CreditManagement.vue?vue&type=script&lang=js"

import "./CreditManagement.vue?vue&type=style&index=0&id=06ab1b42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ab1b42"]])

export default __exports__